import { Location } from 'react-router-dom';

export const checkIsActive = (
  href: string | undefined,
  useExactMatch: boolean,
  location: Location
) => {
  if (!href) return false;

  // Remove query parameters for comparison
  const cleanHref = href.split('?')[0];

  // Special case for host paths
  const pathSegments = location.pathname.split('/');
  if (pathSegments.length >= 2) {
    const secondToLastSegment = pathSegments[pathSegments.length - 2];
    if (secondToLastSegment === 'host') {
      return location.pathname === cleanHref;
    }
  }

  // Standard path matching logic
  if (useExactMatch) {
    return location.pathname === cleanHref;
  } else {
    return (
      location.pathname.startsWith(cleanHref) ||
      location.pathname.startsWith(`/${cleanHref}`)
    );
  }
};
